import { getCloudflareHeaders } from '../headers';
import type { AuthParams } from './authParams';
import { buildLoginQueryString } from './authParams';

/**
 * ***** THIS IS SUPPOSED TO RUN ONLY IN LOCAL OR PREVIEW ENVIRONMENTS *****
 * Authenticates a user with a one-time token (OTT) by making a request to an
 * authentication endpoint. Returns authentication cookies upon success.
 *
 * @async
 * @param {Object} params - The parameters object.
 * @returns {Promise<{status: number, cookieData?: string}>} A promise that resolves to an object containing:
 *   - status: HTTP status code of the authentication response.
 *   - cookieData: (optional) The Set-Cookie header containing authentication credentials if successful.
 */
export const getApiOtt = async (
  params: AuthParams,
): Promise<{ status: number; cookieData?: string }> => {
  try {
    const cloudflareHeaders = getCloudflareHeaders();

    const headers = {
      ...cloudflareHeaders,
    };

    const authEndpoint = '/auth/fake';

    const queryString = buildLoginQueryString(params);

    const authUrl = `${process.env.NEXT_PUBLIC_GQL_API_ENDPOINT_URL}${authEndpoint}?${queryString}`;

    const authResponse = await fetch(authUrl, {
      headers: new Headers(headers),
      redirect: 'manual',
      cache: 'no-store',
    });

    if (![200, 302, 307].includes(authResponse.status)) {
      const responseText = await authResponse.text();

      console.warn(
        `authentication: there was an issue trying to authenticate`,
        JSON.stringify({
          status: authResponse.status,
          text: responseText.substring(0, 3500),
        }),
      );

      return { status: authResponse.status };
    }

    const setCookieHeader = authResponse.headers.get('set-cookie');

    if (!setCookieHeader) {
      console.error('❌ No Set-Cookie header found');

      return { status: 500 };
    }

    return {
      status: 200,
      cookieData: setCookieHeader,
    };
  } catch (error) {
    console.error('❌ Authentication error:', error);

    return { status: 500 };
  }
};
